<template>
  <div class="va-row">
    <div class="flex xs12 md12 w-table recurrings-detail">
      <!-- <vuestic-widget> -->
      <div class="detail-module">
        <!-- <div class="detail-module-header"></div> -->
        <div class="detail-btn-groups">
          <!-- <button class="btn btn-success btn-micro mr-2" @click="recurringsRefund" v-if="isRefund">
            <div class="btn-with-icon-content">
              Refund
            </div>
          </button> -->
          <button class="btn btn-primary btn-micro btn-cancel-recurring mr-2" @click="recurringsCancel" v-if="recurringStatus !== 'Closed' && recurringStatus !== 'Cancelled'">
            <div class="btn-with-icon-content">{{ $t("recurring.cancelRecurring") }}</div>
          </button>
          <button class="btn btn-primary btn-micro" @click="recurringsCallback">
            <div class="btn-with-icon-content">{{ $t("basic.button.callback") }}</div>
          </button>
        </div>
        <vuestic-widget :headerText="$t('recurring.orderInformation')" style="margin-bottom:0!important">
          <div class="table-responsive table-recurring">
            <recurrings-detail-table
              :table-header="orderInformationHeader"
              :table-list="orderInformationList" />
          </div>
        </vuestic-widget>
      </div>
      <vuestic-widget :headerText="$t('recurring.productInformation')" style="margin-bottom:0!important">
        <div class="table-responsive table-recurring">
          <recurrings-detail-table
            :table-header="productInformationHeader"
            :table-list="productInformationList" />
        </div>
      </vuestic-widget>
      <vuestic-widget :headerText="$t('recurring.recurringInformation')" style="margin-bottom:0!important">
        <div class="table-responsive table-recurring">
          <recurrings-detail-table
            :table-header="recurringInformationHeader"
            :table-list="recurringInformationList" />
        </div>
      </vuestic-widget>
      <vuestic-widget :headerText="$t('recurring.transactionsList')" style="margin-bottom:0!important" v-if="transactionsList.length > 0">
        <div class="table-responsive table-recurring">
          <recurrings-detail-table
            :table-header="transactionsHeader"
            :table-list="transactionsList" />
        </div>
      </vuestic-widget>
      <!-- <vuestic-widget headerText="Status History" style="margin-bottom:0!important">
        <div class="table-responsive table-recurring">
          <recurrings-detail-table
            :table-header="statusHistoryHeader"
            :table-list="statusHistoryList" />
        </div>
      </vuestic-widget>
      <vuestic-widget :headerText="$t('recurring.buyerInformation')" style="margin-bottom:0!important" v-if="buyerInformationList.length > 0">
        <div class="table-responsive table-recurring">
          <recurrings-detail-table
            :table-header="buyerInformationHeader"
            :table-list="buyerInformationList" />
        </div>
      </vuestic-widget> -->
    </div>
      <!-- <div class="modals-page" id="refundReason">
        <vuestic-modal
          ref="mediumModal"
          :okText="'modal.confirm2' | translate"
          style="height: 100%; width: 60vw"
          :okClass="'btn btn-primary btn-micro'"
          :cancelClass="'btn btn-secondary btn-micro'"
          :cancelText="'modal.cancel2' | translate"
          @cancel="handleModalClose"
        >
          <div slot="title">{{ "modal.refundReason" | translate }}</div>
          <div>
            <form>
              <div class="va-row">
                <div class="flex xs12 md12">
                  <fieldset>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('refundAmount'),
                        valid: isFormFieldValid('refundAmount'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="simple-input"
                          name="refundAmount"
                          data-vv-as="Name"
                          v-model="refundAmount"
                          v-validate="'required'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="simple-input"
                          >{{
                            "forms.inputs.refundAmount" | translate
                          }}：</label
                        ><i class="bar"></i>
                        <small
                          v-show="errors.has('refundAmount')"
                          class="help text-danger"
                        >
                          {{ errors.first("refundAmount") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('successfulEmail'),
                        valid: isSuccessfulEmailValid,
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="successfulEmail"
                          name="successfulEmail"
                          v-model="successfulEmail"
                          v-validate="'required|email'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="successfulEmail">
                          {{ "forms.inputs.buyerEmail" | translate }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('successfulEmail')"
                          class="help text-danger"
                        >
                          {{ errors.first("successfulEmail") }}
                        </small>
                      </div>
                    </div>

                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('refundExplain'),
                        valid: isFormFieldValid('refundExplain'),
                      }"
                    >
                      <div class="flex md12 xs12" id="textareawrapper">
                        <div class="input-group">
                          <textarea
                            type="text"
                            name="refundExplain"
                            data-vv-as="Name"
                            id="simple-textarea"
                            v-model="refundExplain"
                            placeholder="Up to 100 characters."
                            maxlength="100"
                            rows="2"
                            :style="paddTop"
                            @focus="resizeLabel"
                            @blur="focusLabel"
                            v-validate="'required'"
                            required
                          >
                          </textarea>
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="simple-textarea"
                            >{{
                              "forms.inputs.description" | translate
                            }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('refundExplain')"
                            class="help text-danger"
                          >
                            {{ errors.first("refundExplain") }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('bank'),
                        valid: isFormFieldValid('bank'),
                      }"
                    >
                      <div class="input-group">
                        <el-select
                          id="bank"
                          name="bank"
                          v-model="bankCode"
                          :filterable="true"
                          v-validate="'required'"
                          required
                          placeholder="Please select a bank"
                          @change="selectBankCode"
                        >
                          <el-option
                            v-for="item in bankCodeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <i class="bar" />
                        <small
                          v-show="errors.has('bank')"
                          class="help text-danger"
                        >
                          {{ errors.first("bank") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('clabe'),
                        valid: isFormFieldValid('clabe'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="clabe"
                          name="clabe"
                          v-model="clabe"
                          v-validate="'required'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="clabe">
                          CLABE：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('clabe')"
                          class="help text-danger"
                        >
                          {{ errors.first("clabe") }}
                        </small>
                      </div>
                    </div>
                    <vuestic-checkbox
                      ref="other"
                      v-if="checkCanRefund() && !speiFlag"
                      :label="$t('forms.controls.options')"
                      v-model="checkboxOption"
                    />
                    <div id="user_info" class="" v-if="dispalyOtherFg">
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('username'),
                          valid: isFormFieldValid('username'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="uname-input"
                            name="username"
                            data-vv-as="Name"
                            v-model="username"
                            v-validate="'required'"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="uname-input"
                            >{{ "forms.inputs.username" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('username')"
                            class="help text-danger"
                          >
                            {{ errors.first("username") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('cpfNO'),
                          valid: isFormFieldValid('cpfNO'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="cpfNO-input"
                            name="cpfNO"
                            data-vv-as="Name"
                            v-model="cpfNO"
                            v-validate="'required'"
                            maxlength="14"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="cpfNO-input"
                            >{{ "forms.inputs.cpfNO" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('cpfNO')"
                            class="help text-danger"
                          >
                            {{ errors.first("cpfNO") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('agency'),
                          valid: isFormFieldValid('agency'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="agency-input"
                            name="agency"
                            data-vv-as="Name"
                            v-model="agency"
                            v-validate="'required'"
                            maxlength="6"
                            onkeyup="this.value=this.value.replace(/[^a-zA-Z0-9\-]/g,'')"
                            ondragenter="return false"
                            ondragover="return false"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="agency-input"
                            >{{ "forms.inputs.agency" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('agency')"
                            class="help text-danger"
                          >
                            {{ errors.first("agency") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        id="bankWrapper"
                        :class="{
                          'has-error': initSelectedVaild,
                          valid: isBankVaild(selBank),
                        }"
                      >
                        <div class="input-group">
                          <vuestic-simple-select
                            label="Bank"
                            name="selBank"
                            data-vv-as="Name"
                            v-model="selBank"
                            ref="bankInput"
                            @input="forbiddenInput"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            option-key="description"
                            v-bind:options="bankOptions"
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <small
                            v-show="initSelectedVaild"
                            class="help text-danger"
                            style="display: block; margin-top: -30px"
                          >
                            {{ errors.first("selBank") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        id="accountWrapper"
                        :class="{
                          'has-error': initSelAccoutTypeVaild,
                          valid: isAccountVaild(accountType),
                        }"
                      >
                        <div class="input-group">
                          <vuestic-simple-select
                            label="Account Type"
                            name="accountType"
                            data-vv-as="Name"
                            v-model="accountType"
                            ref="accountInput"
                            @input="forbiddenAccountInput"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            option-key="description"
                            v-bind:options="accountOptions"
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <small
                            v-show="initSelAccoutTypeVaild"
                            class="help text-danger"
                            style="display: block; margin-top: -30px"
                          >
                            {{ errors.first("accountType") }}
                          </small>
                        </div>
                      </div>
                      <div class="form-group with-icon-right">
                        <div class="input-group">
                          <input
                            id="card_number"
                            name="card_number"
                            data-vv-as="Name"
                            v-model="bankAccountNumberFirst"
                            v-validate="'required'"
                            style="display: inline-block; width: 60%"
                            onpaste="return false"
                            ondragenter="return false"
                            ondragover="return false"
                            maxlength="14"
                            @focus="formatCardNumber($event)"
                            required
                          />
                          <span>—</span>
                          <input
                            id="branch_num"
                            name="branch_num"
                            data-vv-as="Name"
                            v-model="bankAccountNumberLast"
                            v-validate="'required'"
                            style="
                              display: inline-block;
                              width: 20%;
                              padding-left: 10px;
                            "
                            maxlength="2"
                            onkeyup="this.value=this.value.replace(/\D/g,'')"
                            onkeydown="this.value=this.value.replace(/\D/g,'')"
                            onpaste="return false"
                            ondragenter="return false"
                            ondragover="return false"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="card_number"
                            >{{
                              "forms.inputs.bankAccountNumber" | translate
                            }}：</label
                          ><i class="bar"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('userPass'),
                        valid: isFormFieldValid('userPass'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          name="userPass"
                          data-vv-as="Password"
                          type="password"
                          id="password"
                          v-model="userPass"
                          v-validate="'required'"
                          required="required"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="password">
                          {{ $t("auth.password") }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('userPass')"
                          class="help text-danger"
                          >{{ errors.first("userPass") }}</small
                        >
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </vuestic-modal>
      </div> -->
      <vuestic-modal show.sync="true"
                      ref="cancelRecurring"
                      :okText="'modal.confirm2' | translate"
                      :okClass="'btn btn-primary btn-micro'"
                      alignModal=""
                      :small="true"
                      cancelClass="cancel-recurring"
                      >
        <div slot="title">{{ $t("recurring.cancelRecurring") }}</div>
        <vuestic-widget>
          <div class="form-group with-icon-right"
              style="padding-top:0;margin-bottom:-30px"
                :class="{'has-error': errors.has('cancelPassword'), 'valid': isFormFieldValid('cancelPassword')}">
            <div class="input-group">
              <input name="cancelPassword"
                      data-vv-as="password"
                      v-model="cancelPassword"
                      autocomplete="off"
                      v-validate="'required'"
                      required
                      type="password"
                      onkeyup="value=value.replace(/\s/g,'')"
                      onkeydown="value=value.replace(/\s/g,'')" />
              <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
              <i class="fa fa-check valid-icon icon-right input-icon"></i>
              <label class="control-label"
                      for="cancelPassword">Password：</label>
              <i class="bar"></i>
              <small v-show="errors.has('cancelPassword')"
                      class="help text-danger">{{ errors.first('cancelPassword') }}</small>
            </div>
          </div>
        </vuestic-widget>
      </vuestic-modal>

  </div>
</template>
<script>
import RecurringsDetailTable from "./RecurringsDetailTable.vue"
import { request,formatUserCredentials  } from "@/utils/utils.js";
let moment = require("moment-timezone");

export default {
  name: 'RecurringsDetail',
  components:{
    RecurringsDetailTable
  },
  props: {
    // childTransactionId: {
    //   type: String,
    //   default: ""
    // },
    // paymentOrderVisible: {
    //   type: Boolean,
    //   default: false
    // },
    // appId: {
    //   type: String,
    //   default: ''
    // },
    // recurringBean: {
    //   type: Object,
    //   default: () => {}
    // },
  },
  // watch: {
  //   paymentOrderVisible: function (value) {
  //     if (value) {
  //       let that = this
  //       that.$nextTick(() => {
  //         that.fetchDetails();
  //       })
  //     }
  //   }
  // },
  provide(){
      return {
        currTimeZone: () => this.$route.query.currTimeZone
    }
  },
  data() {
    return {
      orderInformationHeader: [
        // {label: 'tables.listing.recurring_transaction_id'},
        {label: 'tables.listing.recurring_merchant_reference'},
        {label: 'tables.listing.recurring_status'},
        {label: 'tables.listing.recurring_create_time'},
        // {label: 'tables.listing.recurring_method'},
        {label: 'tables.listing.recurring_order_amount'},
      ],
      orderInformationList: [{}],
      productInformationHeader: [
        { label: "tables.listing.app_name" },
        { label: "tables.apping.appId" },
        { label: "subject" },
      ],
      productInformationList: [{}],
      recurringInformationHeader: [
        { label: "tables.listing.recurring_interval" },
        { label: "tables.listing.recurring_quantity" },
        { label: "recurring.currentStage" },
        { label: "tables.listing.recurring_trial_amount" },
        { label: "recurring.previousTime" },
        { label: "recurring.nextTime" },
      ],
      recurringInformationList: [],
      statusHistoryHeader: [
        { label: "tables.listing.recurring_status" },
        { label: "tables.listing.updateTime" },
        { label: "t.amount" },
        { label: "tables.detailsInfo.cbStatus" },
      ],
      statusHistoryList: [],
      buyerInformationHeader: [
        { label: "payment.buyerName" },
        { label: "cpfCnpj" },
        { label: "tables.listing.recurring_buyer_id" },
        { label: "payment.cellNumber" },
        { label: "contactEmail" },
      ],
      buyerInformationList: [],
      transactionsHeader: [
        { label: "tables.listing.recurring_transaction_id" },
        // { label: "tables.listing.recurring_create_time" },
        { label: "tables.listing.recurring_order_amount" },
        { label: "tables.listing.recurring_status" },
      ],
      transactionsList: [],
      // isRefund: false,

      // refund 相关
      // refundAmount: "",
      // successfulEmail: "",
      // clabe: "",
      // refundExplain: "",
      // userPass: "",
      toastText: "Application for refund has been submitted!",
      toastIcon: "fa-star-o",
      toastPosition: "top-center",
      isToastFullWidth: false,
      toastDuration: 2500,
      isToastContentPresent: false,
      // loading: null,
      recurringId: null,
      recurringStatus: '',
      cancelPassword: '',
    }
  },
  mounted() {
    try {
      const recurringBean = JSON.parse(localStorage.getItem("recurringBean"));
      const subOrdersList = JSON.parse(localStorage.getItem("subOrdersList"));
      this.renderRecurringDetail(recurringBean, subOrdersList);
    }catch(e){}
    // if (this.paymentOrderVisible) {
    //   let that = this
    //   that.$nextTick(() => {
    //     that.fetchDetails();
    //   })
    // }
  },
  methods: {
    launchToast() {
      this.isToastContentPresent = true;
      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth,
      });
      this.isToastContentPresent = false;
    },
    recurringsCallback() {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
      // return
      this.isLoading = true
      let token = localStorage.getItem('Authorization')
      let out_trade_no = this.orderInformationList[0].out_trade_no
      let app_id = this.productInformationList[0].app_id
      request({
        method: 'post',
        url: `api/dashboard/order/callback?access_token=${token}&app_id=${app_id}&out_trade_no=${out_trade_no}`,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        let code = res.data.code
        if (code == 10000) {
          this.toastText = res.data.msg || 'Success!'
          this.launchToast()
        } else {
          this.toastText = res.data.msg
          this.launchToast()
        }
        this.isLoading = false
        this.searching.close();
      }).catch(err => {
        this.toastText = err.msg
        this.launchToast()
        this.isLoading = false
        this.searching.close();
      })
    },
    recurringsCancel() {
      this.$refs.cancelRecurring.open()
      const that = this;
      that.$refs.cancelRecurring.ok = () => {
        that.$validator.validateAll({cancelPassword: that.cancelPassword}).then((result) => {
          if (result) {
            that.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
            that.isLoading = true
            let token = localStorage.getItem('Authorization')
            let app_id = that.productInformationList[0].app_id
            request({
              method: 'post',
              url: `api/dashboard/recurring/cancel?access_token=${token}&recurring_id=${that.recurringId}&password=${that.cancelPassword}`,
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(res => {
              let code = res.data.code
              if (code == 10000) {
                that.toastText = res.data.msg || 'Success!'
                that.launchToast()
                that.$router.push({name: "Recurring"});
              } else if (code == 80031) { // 密码错误
                that.toastText = "The password is incorrect."
                that.launchToast()
              } else {
                that.toastText = res.data.msg
                that.launchToast()
              }
              that.isLoading = false
              that.searching.close();
            }).catch(err => {
              that.toastText = err.msg
              that.launchToast()
              that.isLoading = false
              that.searching.close();
            })
          }
        })
      }
      that.$refs.cancelRecurring.cancel = () => { this.cancelPassword="";that.$refs.cancelRecurring.close() }
    },
    renderRecurringDetail(orderData, subOrdersList) {
      // cancel时参数
      this.recurringId = orderData.id;
      // 判断是否隐藏取消按钮 closed 和 cancelled 状态的订阅订单详情里应该不显示取消订阅按钮
      this.recurringStatus = orderData.recurring_status;
      let orderInformation = {}
      orderInformation.out_trade_no = orderData.out_trade_no ? orderData.out_trade_no : 'N/A'
      orderInformation.trade_status = orderData.recurring_status ? orderData.recurring_status : "N/A";
      orderInformation.create_time = orderData.create_time ? this.dateFormat(orderData.create_time) : "N/A";
      orderInformation.order_amount =
        orderData.order_currency && orderData.order_amount ? `${orderData.order_currency} ${orderData.order_amount.toFixed(2)}` : "N/A";
      this.$set(this.orderInformationList, 0, orderInformation);

      let productInformation = {};
      productInformation.app_name = orderData.app_name ? orderData.app_name : "N/A";
      productInformation.app_id = orderData.app_id ? orderData.app_id : "N/A";
      productInformation.subject = orderData.subject ? orderData.subject : "N/A";
      this.$set(this.productInformationList, 0, productInformation);
      // Status History
      // Buyer Information
      // this.recurringBean
      this.$set(this.recurringInformationList, 0, {
        recurring_interval: orderData.recurring_interval ? orderData.recurring_interval + "" : 'N/A',
        recurring_quantity: orderData.recurring_quantity ? orderData.recurring_quantity + "" : 'N/A',
        current_stage: orderData.current_stage ? orderData.current_stage + "" : 'N/A',
        trial_amount: orderData.order_currency && orderData.trial_amount ? `${orderData.order_currency} ${orderData.trial_amount.toFixed(2)}` : "N/A",
        prev_exec_time: orderData.prev_exec_time ? orderData.prev_exec_time + "" : "N/A",
        next_exec_time: orderData.next_exec_time ? orderData.next_exec_time + "" : "N/A",
      });
      if (subOrdersList && subOrdersList.length > 0) {
        subOrdersList.forEach((item, index) => {
          this.$set(this.transactionsList, index, {
            child_transaction_id: item.trade_no || "N/A",
            // child_create_time: item.create_time || "N/A",
            child_order_amount: item.order_currency && item.order_amount ? `${item.order_currency} ${item.order_amount.toFixed(2)}` : "N/A",
            child_status: item.status || "N/A",
          })
        })
      }
    },
    // fetchDetails() {
    //   this.loading = this.$loading({
    //     lock: true,
    //     text: "Loading",
    //     spinner: "el-icon-loading",
    //     background: "rgba(0, 0, 0, 0.7)",
    //   });
    //   // childTransactionId = "2022041310453400266"
    //   localStorage.setItem("tid", this.childTransactionId);
    //   this.getOrderInfoById();
    // },
    // 获取订单信息
    // getOrderInfoById() {
    //   this.loading.close();
    //   let tid = this.childTransactionId
    //   if (!tid) {
    //     this.loading.close();
    //     return
    //   }
    //   let token = localStorage.getItem("Authorization");
    //   // this.$set(this.depositUpload, "uploadUrl", "");
    //   request({
    //     method: "post",
    //     url: `api/dashboard/order/queryById?access_token=${token}&app_id=${this.appId}&out_trade_no=${tid}`,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then((res) => {
    //       // 清空历史列表
    //       // this.statusHistoryInfo.splice(0, this.statusHistoryInfo.length);
    //       if (res.status === 200) {
    //         let orderData = res.data;
    //         if (orderData.code === "10000") {
    //           orderData = orderData.data;
    //           this.orderDataConfig(orderData)
    //           // 隐藏loading
    //           setTimeout(() => {
    //             this.loading.close();
    //           }, 200);
    //         } else {
    //           // 隐藏loading
    //           setTimeout(() => {
    //             this.loading.close();
    //           }, 200);
    //           this.$message({
    //             message: "System error, please refresh and try again!",
    //             type: "warning",
    //           });
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       // 隐藏loading
    //       setTimeout(() => {
    //         this.loading.close();
    //       }, 200);
    //       console.log(err);
    //     });
    // },
    // orderDataConfig(orderData) {
    //   let orderInformation = {}
    //   orderInformation.trade_no = orderData.detail.trade_no
    //     ? orderData.detail.trade_no
    //     : "N/A";
    //   orderInformation.out_trade_no = orderData.detail.out_trade_no
    //   orderInformation.trade_status = orderData.detail.trans_base.trade_status
    //     ? orderData.detail.trans_base.trade_status
    //     : "N/A";
    //   orderInformation.create_time = orderData.detail.trans_base.create_time
    //     ? this.dateFormat(orderData.detail.trans_base.create_time)
    //     : "N/A";
    //   orderInformation.method = orderData.detail.trans_base.method
    //     ? orderData.detail.trans_base.method
    //     : "N/A";
    //   orderInformation.order_amount =
    //     orderData.detail.trans_base.order_currency &&
    //     orderData.detail.trans_base.order_amount
    //       ? `${orderData.detail.trans_base.order_currency} ${orderData.detail.trans_base.order_amount}`
    //       : "N/A";
    //   this.$set(this.orderInformationList, 0, orderInformation);

    //   let productInformation = {};
    //   productInformation.app_name = orderData.detail.trans_base.app_name ? orderData.detail.trans_base.app_name : "N/A";
    //   productInformation.app_id = orderData.detail.trans_base.app_id ? orderData.detail.trans_base.app_id : "N/A";
    //   productInformation.subject = orderData.detail.trans_base.subject ? orderData.detail.trans_base.subject : "N/A";
    //   this.$set(this.productInformationList, 0, productInformation);

    //   // let isMethod = [
    //   //   "CreditCard",
    //   //   "Boleto",
    //   //   "Lottery",
    //   //   "DepositExpress",
    //   //   "PIX",
    //   //   "Pix",
    //   //   "Wallet",
    //   //   "SPEI",
    //   // ].includes(orderData.detail.trans_base.method);
    //   // if (isMethod === true && (orderData.detail.trans_base.trade_status === "Success" || orderData.detail.trans_base.trade_status === "PartialRefund")) {
    //   //   this.isRefund = true
    //   // } else {
    //   //   this.isRefund = false
    //   // }
    //   // this.checkCanRefund();

    //   // Status History
    //   for (let i = 0; i < orderData.detail.trans_logs.length; i++) {
    //     let statusHistory = {};
    //     let refundMoney = orderData.detail.trans_logs[i].amount ? orderData.detail.trans_logs[i].currency + " " + orderData.detail.trans_logs[i].amount : orderData.detail.trans_base.order_amount ? orderData.detail.trans_base.order_currency + " " + orderData.detail.trans_base.order_amount : "N/A";
    //     statusHistory.log_status = orderData.detail.trans_logs[i].log_status
    //         ? orderData.detail.trans_logs[i].log_status
    //         : "N/A"
    //     statusHistory.refund_create_time = orderData.detail.trans_logs[i].create_time ? this.dateFormat( orderData.detail.trans_logs[i].create_time ) : "N/A";
    //     statusHistory.refund_amount = refundMoney;
    //     statusHistory.callback_status = orderData.detail.trans_logs[i].log_callback_status ? orderData.detail.trans_logs[i].log_callback_status : "N/A";
    //     this.$set(this.statusHistoryList, i, statusHistory);
    //   }

    //   // Buyer Information
    //   let buyerInfo = {};
    //   if (orderData.detail.trans_base) {
    //     if (orderData.detail.trans_base.payment_info) {
    //       var amountMoney = "N/A";
    //       var amountCurrency = "";
    //       var payAmount = {
    //         type: "",
    //         number: "",
    //       };
    //       var payIdentify =
    //         orderData.detail.trans_base.payment_info.identify;
    //       if (payIdentify) {
    //         if (typeof payIdentify === "string") {
    //           amountCurrency =
    //             orderData.detail.trans_base.payment_info.currency;
    //           if (payIdentify.length <= 12) {
    //             payAmount = {
    //               type: "cpf",
    //               number: payIdentify,
    //             };
    //           } else if (payIdentify.length > 13) {
    //             payAmount = {
    //               type: "cnpj",
    //               number: payIdentify,
    //             };
    //           }
    //         } else if (
    //           Object.prototype.toString.call(payIdentify) ===
    //           "[object Object]"
    //         ) {
    //           payAmount = {
    //             type: payIdentify.type,
    //             number: payIdentify.number,
    //           };
    //         }
    //       }
    //       buyerInfo.buyer_name = orderData.detail.trans_base.payment_info.buyer_name || "N/A";
    //       buyerInfo.pay_identify = payIdentify ? formatUserCredentials(payAmount.type, payAmount.number) : "N/A";
    //       buyerInfo.muid = (orderData.detail.trans_base.user_info ? orderData.detail.trans_base.user_info.buyer_id : "N/A") || "N/A";
    //       buyerInfo.email = orderData.detail.trans_base.payment_info.email || "N/A";
    //       buyerInfo.phone_number = orderData.detail.trans_base.payment_info.phone || "N/A";
    //     } else {
    //       buyerInfo.buyer_name = "N/A";
    //       buyerInfo.pay_identify = "N/A";
    //       buyerInfo.muid = (orderData.detail.trans_base.user_info
    //             ? orderData.detail.trans_base.user_info.buyer_id
    //             : "N/A") || "N/A";
    //       buyerInfo.email = "N/A";
    //       buyerInfo.phone_number = "N/A";
    //     }
    //     this.$set(this.buyerInformationList, 0, buyerInfo);
    //   }
    //   // this.recurringBean
    //   this.$set(this.recurringInformationList, 0, {
    //     recurring_interval: this.recurringBean.recurring_interval + "",
    //     recurring_quantity: this.recurringBean.recurring_quantity + "",
    //     current_stage: this.recurringBean.current_stage + "",
    //     trial_amount: this.recurringBean.trial_amount + "",
    //     prev_exec_time: this.recurringBean.prev_exec_time + "",
    //     next_exec_time: this.recurringBean.next_exec_time + "",
    //   });
    //   // this.speiFlag = orderData.detail.trans_base.method == "SPEI" ? true : false;
    //   // this.refundAmount = orderData.detail.trans_base.order_amount;
    //   // this.refundAmount = orderData.refundable_amount;
    //   // this.successfulEmail = orderData.detail.trans_base.user_info
    //   //   ? orderData.detail.trans_base.user_info.email
    //   //   : "N/A"; // 用户的邮箱
    //   // this.refundExplain = this.orderInformationList[2]; // 拒绝的描述
    //   // 设置交易信息
    //   // this.transactionInfo = [];
    //   // if (orderData.detail.trans_base) {
    //   //   if (orderData.detail.trans_base.processing_fee_detail) {
    //   //     let processing_fee_detail = JSON.parse(
    //   //       orderData.detail.trans_base.processing_fee_detail
    //   //     );
    //   //     this.transactionInfo.push(processing_fee_detail.feeName);
    //   //     this.transactionInfo.push(processing_fee_detail.ext);
    //   //     this.transactionInfo.push(processing_fee_detail.feeAmount);
    //   //   }
    //   // }

    // },
    dateFormat(value) {
      return moment
        .tz(moment.tz(value, "UTC"), this.$route.query.currTimeZone)
        .format("YYYY-MM-DD HH:mm:ss");
    },

    // refund 相关
    handleModalClose() {
      this.clabe = ""
      this.bankCode = ""
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
					this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    // recurringsRefund() {
    //   this.single =
    //   this.userPass =
    //   this.username =
    //   this.cpfNO =
    //   this.agency =
    //   this.selBank =
    //   this.accountType =
    //   this.bankAccountNumberFirst =
    //   this.bankAccountNumberLast =
    //   this.clabe =
    //   this.bankCode = "";
    //   this.selectedBank = {};
    //   if (
    //     this.orderInformationList.method === "CreditCard" ||
    //     this.orderInformationList.method === "Wallet"
    //   ) {
    //     this.checkboxOption = false;
    //     this.$refs.mediumModal.open();
    //     this.$refs.mediumModal.style = "";
    //     // 限制拒绝退款的调用频率
    //     var callFrequency2Refund = {
    //       orderId: this.orderInformationList[0].trade_no,
    //       dataTime: new Date().getTime(), //  每1分钟才能重发
    //       countCk: 0,
    //     };
    //     this.$refs.mediumModal.ok = (callFrequency2Refund) => {
    //       this.toSubmitRefundData(callFrequency2Refund);
    //     };
    //   } else if (this.checkCanRefund()) {
    //     // TODO
    //     this.$refs.mediumModal.open();
    //     this.$refs.mediumModal.style = "";
    //     // 限制拒绝退款的调用频率
    //     var callFrequency2Refund = {
    //       orderId: this.orderInformationList[0].trade_no,
    //       dataTime: new Date().getTime(), //  每1分钟才能重发
    //       countCk: 0,
    //     };
    //     this.$refs.mediumModal.ok = (callFrequency2Refund) => {
    //       this.toSubmitRefundData(callFrequency2Refund, this.checkboxOption);
    //     };
    //   } else {
    //     return;
    //   }
    // },
    // // 退款confirm 点击事件
    // toSubmitRefundData(callBkObj, others) {
    //   if (this.refundCanDo === false) {
    //     return;
    //   }
    //   if (!this.refundAmount) {
    //     return;
    //   }
    //   if (!this.successfulEmail) {
    //     return;
    //   }
    //   if (!this.refundExplain) {
    //     return;
    //   }
    //   if (!this.userPass) {
    //     return;
    //   }
    //   // 其他现金支付提交
    //   if (others) {
    //     if (this.dispalyOtherFg) {
    //       if (!this.username) {
    //         return;
    //       }
    //       if (!this.cpfNO) {
    //         return;
    //       }
    //       if (!this.agency) {
    //         return;
    //       }
    //       if (!this.selBank) {
    //         return;
    //       }
    //       if (!this.accountType) {
    //         return;
    //       }
    //       if (!this.bankAccountNumberFirst) {
    //         return;
    //       }
    //       if (!this.bankAccountNumberLast) {
    //         return;
    //       }
    //     } else {
    //         this.username =
    //         this.cpfNO =
    //         this.agency =
    //         this.selBank =
    //         this.accountType =
    //         this.bankAccountNumberFirst =
    //         this.bankAccountNumberLast =
    //           "";
    //     }
    //   } else {
    //     if (this.speiFlag) {
    //       if (!this.bankCode) {
    //         return;
    //       }
    //       if (!this.clabe) {
    //         return;
    //       }
    //     }
    //   }
    //   this.commitRefundInfo(callBkObj);
    // },
    // // 提交退款相关的信息
    // commitRefundInfo(ckObj) {
    //   let trade_no = this.$route.params.tid || localStorage.getItem("tid");
    //   if (trade_no === ckObj.orderId && ckObj.countCk > 1) {
    //     this.refundCanDo = false;
    //     return;
    //   }
    //   let token = localStorage.getItem("Authorization");
    //   const param = new FormData();
    //   param.append("trade_no", trade_no);
    //   param.append("amount", this.refundAmount);
    //   param.append("email", this.successfulEmail);
    //   param.append("desc", this.refundExplain);
    //   // param.append("clabe", this.clabe);
    //   // param.append("bank_code", this.bankCode);
    //   param.append("password", this.userPass);
    //   if (this.dispalyOtherFg) {
    //     param.append("identify", this.cpfNO.replace(".", "").replace("-", ""));
    //     param.append("username", this.username);
    //     let bankInfo = {
    //       bank_id: this.selBank.value,
    //       bank_name: this.selBank.description,
    //       agency: this.agency,
    //       type: "" + this.accountType.id,
    //       number:
    //         this.bankAccountNumberFirst.replace(/\s/g, "") +
    //         "-" +
    //         this.bankAccountNumberLast,
    //     };
    //     param.append("bank_info", JSON.stringify(bankInfo));
    //   }
    //   if (this.speiFlag) {
    //     let bankInfo = {
    //       bank_id: this.selectedBank.value,
    //       bank_name: this.selectedBank.label,
    //       number: this.clabe,
    //     }
    //     param.append("bank_info", JSON.stringify(bankInfo));
    //   }
    //   this.$refs.mediumModal.close();
    //   request({
    //     method: "post",
    //     url: `api/dashboard/order/refund?access_token=${token}`,
    //     data: param,
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   }).then(res => {
    //     ckObj.countCk++
    //     let code = res.data.code
    //     if (code == 10000) {
    //       this.toastText = res.data.msg || 'Success!'
    //       this.dialogTableVisible = false;
    //       this.launchToast()
    //       setTimeout(function() {
    //         this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
    //        this.orderData()
    //       }, 20);
    //     } else {
    //       this.toastText = res.data.sub_msg
    //       this.launchToast()
    //     }
    //   }).catch(err => {
    //     this.toastText = err.msg || "Business Failed"
    //     this.launchToast()
    //   });
    // },
  }
}
</script>
<style lang="scss" scoped>
.detail-module {
  position: relative;
  .detail-btn-groups {
    position: absolute;
    top: 10px;
    right: 40px;
    .btn-cancel-recurring {
      background-color: #EA7676;
    }
  }
  // .detail-module-header {
  //   display: flex;
  //   flex-direction: row;
  //   line-height: 44px;
  //   padding-bottom: 15px;
  //   margin-bottom: 15px;
  //   justify-content: space-between;
  //   border-bottom: 2px solid #797979;
  //   // .detail-btn-groups {}
  // }
}
.recurrings-detail {
  padding: 20px;
  margin-bottom: 50px;
  background-color: #ffffff;
}
/deep/ .vuestic-widget-body {
  padding-bottom: 0;
  padding-top: 0;
}
/deep/ .table-recurring {
  margin-bottom: 0!important;
}
/deep/ .cancel-recurring {
  display: none;
}

</style>
